import React, { useEffect, useState } from "react";
import {MONTHS,WEEKDAYS_SHORT}  from '../../../constants';
import {tConv24,everyNminutes, rearrangeDataForWeekView, calendarWidgetVisitTypeBasedColor} from '../../../calendarFunctions'; 
import { isSet } from "../../../../../utils/commonUtils"; 
import Wrap from "../../../../../hoc/Wrap";
const timeToMinutes = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;
  return hours * 60 + minutes;
};

const DayViewBody = (props) => {
  const {
    timeInterval,
    showMoreDetailsDataHandler,
    addVisitToogleHandler,
    calendarRecords,
    currentDate,
    currentDayDetails,
    blockedDates = [],
    blockedDays = [],
    availabilitySlots = {},
    showQuickVisitView,
  } = props;
  const weekdayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const calendarWeeksRecords = rearrangeDataForWeekView(calendarRecords);
  const [maxSlotDisplay, setMaxSlotDisplay] = useState(3);
  
	useEffect(()=>{
		const updateMaxSlotDisplay = () => {
			const calendarDiv = document.getElementById('calendar');
			if (calendarDiv) {
			  const calendarRect = calendarDiv.getBoundingClientRect();
			  const { width } = calendarRect;
			  setMaxSlotDisplay(Math.floor(width / 180));
			  // console.log('calendarRect', Math.floor(width / 180));
			}
		  };
	  
		  // Initial calculation
		  updateMaxSlotDisplay();
	  
		  // Add event listener for resize
		  window.addEventListener('resize', updateMaxSlotDisplay);
	  
		  // Cleanup event listener on component unmount
		  return () => {
			window.removeEventListener('resize', updateMaxSlotDisplay);
		  };
	},[])
	return(
		<tbody className="fc-body">
            <tr>
                <td className="fc-widget-content">
                   
                    <div className="fc-scroller fc-time-grid-container" /* style={{height:'653.109px'}} */  >
                        <div className="fc-time-grid">
                            <div className="fc-bg">
                                  <table className="">
                                     <tbody>
                                        <tr>
                                           <td className="fc-axis fc-widget-content" style={{width:'46.7188px'}}></td>
                                           <td className="fc-day fc-widget-content fc-sun fc-past" data-date={props.currentDate}></td>
                                        </tr>
                                     </tbody>
                                  </table>
                            </div>  
                            <div className="fc-slats">
                                <table className="">
                                    <tbody>
                    {timeInterval.map((time, timeIndex) => {
                      const timeIn12 = tConv24(time);
                      const timeMinutes = timeToMinutes(timeIn12);

                      // Check once for the whole row (if you want row-wide blocking)
                      const firstDay = currentDayDetails[0];
                      const weekdayName = weekdayNames[new Date(firstDay.date).getDay()];
                      const holiday = blockedDates.find(b => b.date === firstDay.c_date);
                      const isDayBlocked = blockedDays.includes(weekdayName);
                      const slots = availabilitySlots[weekdayName] || [];
                      let isTimeAllowed = true;
                      if (slots.length > 0) {
                        isTimeAllowed = slots.some(slot =>
                          timeMinutes >= timeToMinutes(slot.from_time) &&
                          timeMinutes <= timeToMinutes(slot.to_time)
                        );
                      }
                      const isBlocked =
                        !!holiday || isDayBlocked || (slots.length > 0 && !isTimeAllowed);

                      const tooltip = holiday
                        ? holiday.reason
                        : isDayBlocked
                        ? "Clinic Not Available"
                        : (slots.length > 0 && !isTimeAllowed)
                        ? "Outside Available Hours"
                        : "";

                      return (
                        <Wrap key={timeIndex}>
                          {/* Main Row */}
                          <tr data-time={time}>
                            {/* Time label */}
                            <td className="fc-axis fc-time fc-widget-content" style={{ width: "46.7px" }}>
                              <span>{timeIn12}</span>
                            </td>

                            {/* Single TD containing all day details */}
                            <td
                              className={`fc-widget-content  ${isBlocked ? "fc-day-blocked sh-dayView" : "sh-dayView"}`}
                              style={isBlocked ? { cursor: "not-allowed" } : {}}
                              title={tooltip}
                              onClick={() => {
                                if (!isBlocked) {
                                  addVisitToogleHandler({
                                    visit_date: firstDay.c_date,
                                    visit_time: timeIn12,
                                  });
                                }
                              }}
                            >
                              {currentDayDetails.map((dateItem, ind) => {
                                const itemData = isSet(
                                  calendarWeeksRecords?.[dateItem.c_date]?.[timeIn12],
                                  []
                                );

                                return itemData.map((item, idx) => {
                                  if (idx+1 >maxSlotDisplay) return false;
                                  const typeBasedClass = calendarWidgetVisitTypeBasedColor(item.visit_category);
                                  return (
                                    <React.Fragment key={`${ind}-${idx}`}>
                                      <a
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          showQuickVisitView(e, item);
                                        }}
                                      >
                                        <div
                                          className={`mainValueTag ${typeBasedClass}`}
                                          style={{ width: "160px" }}
                                          title={`${item.visit_time} : ${item.employee.first_name} ${item.employee.last_name}`}
                                        >
                                          <span className="text-sm font-weight-bold">{item.visit_time}</span>
                                          <span className="font-weight-bold"> : </span>
                                          <span className="text-sm">
                                            {item.employee.first_name} {item.employee.last_name}
                                          </span>
                                        </div>
                                      </a>
                                      {(idx + 1 )=== maxSlotDisplay && itemData.length > maxSlotDisplay && (
                                        <a
                                          className="text-danger textUnderline text-small quick-sidebar-toggler cursor-pointer"
                                          style={{ display: "block", textAlign: "right" }}
                                          onClick={(e) =>
                                            showMoreDetailsDataHandler(
                                              e,
                                              { date: dateItem.c_date, time: timeIn12 },
                                              isSet(itemData, [])
                                            )
                                          }
                                        >
                                          + More ...
                                        </a>
                                      )}
                                    </React.Fragment>
                                  );
                                });
                              })}
                            </td>
                          </tr>

                          {/* Minor Row */}
                          <tr className="fc-minor" id={`calendarRow_${time.toString().replace(":", "")}`}>
                            <td className="fc-axis fc-time fc-widget-content" style={{ width: "46.7px" }}></td>
                            <td
                              className={`fc-widget-content ${isBlocked ? "fc-day-blocked sh-dayView" : ""}`}
                              style={isBlocked ? { cursor: "not-allowed" } : {}}
                              title={tooltip}
                            />
                          </tr>
                        </Wrap>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default DayViewBody;;